import { render } from "./StageClosedCurtain.vue?vue&type=template&id=318bda7c"
import script from "./StageClosedCurtain.vue?vue&type=script&lang=js"
export * from "./StageClosedCurtain.vue?vue&type=script&lang=js"

import "./StageClosedCurtain.vue?vue&type=style&index=0&id=318bda7c&lang=scss"
script.render = render

export default script